import EF from 'ef/ef';
import Backbone from 'backbone';
import _ from 'lodash';

const ContentPage = Backbone.Model.extend({
  initialize: function () {
    const self = this;
    this.pageData = {};
    if (this.get('key')) {
      this.key = this.get('key');
    }
    // Bind all the methods to the current scope
    _.bindAll(this, 'complete', 'unload', 'play', 'init', 'pause', 'stop', 'reload', 'unpause', 'mute', 'setProgress');

    this.on('play', function () {
      this._startedPlaying = true;
    });
    this.on('pause', function () {
      this._isPaused = true;
    });
    this.on('unpause', function () {
      this._isPaused = false;
    });
    this.on('reload', function () {
      this._startedPlaying = false;
      this._isPaused = false;
    });
    this.on('change:completed', function () {
      if (self.get('completed')) {
        self.completed = true;
      } else {
        self.completed = false;
      }
    });
  },
  unload: function () {
    this.trigger('unload');
  },
  play: function () {},
  init: function () {},
  pause: function () {},
  stop: function () {},
  reload: function () {},
  unpause: function () {},
  mute: function () {},
  complete: function () {
    this.trigger('complete');
  },

  setProgress: function (progressObj) {
    if (!progressObj) {
      this.progress = {
        key: this.key,
        completed: false,
      };
      this.set('completed', false);
    } else {
      this.progress = progressObj;
      if (progressObj.data) {
        this.pageData = progressObj.data;
        this.set('pageData', this.pageData);
      }
      this.set('completed', progressObj.completed);
    }
    EF.trigger('page:progress:set', this);
  },
});

export default ContentPage;
